import banners from "./banners";
import boards from "./boards";
import center from "./center";
import fairs from "./fairs";
import forms from "./forms";
import honja from "./honja";
import me from "./me";
import message from "./message";
import setting from "./setting";
import shop from "./shop";
import policies from "./policies";
import users from "./users";
import popups from "./popups";

export default {
    banners,
    boards,
    center,
    fairs,
    forms,
    honja,
    me,
    message,
    setting,
    shop,
    policies,
    users,
    popups,
};
